import { useEffect, useState } from 'react';
export function useElementHasScroll(labelRef) {
    const [hasScroll, setHasScroll] = useState(false);
    useEffect(() => {
        const element = labelRef.current;
        if (element) {
            const observer = new ResizeObserver(() => {
                const hasScroll1 = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
                setHasScroll(hasScroll1);
            });
            observer.observe(element);
            return () => {
                observer.unobserve(element);
            };
        }
    }, []);
    return hasScroll;
}
